import { Grid, Typography } from '@mui/material';
import Section from 'components/Section';

import React from 'react';
import { User } from 'types';
import TextField from 'components/Inputs/TextField';

const QnASection: React.FC<{ employee: User }> = ({ employee }) => {
  return (
    <Section title="Promotional Questions" collapsible>
      <Grid container direction={'column'} rowGap={2}>
        {employee.promotionQuestions.map(qa => {
          return (
            <Grid container item flexDirection={'column'}>
              <Grid item display={'flex'} alignItems={'center'} columnGap={1}>
                <Typography variant="subtitle1">Q:</Typography>
                <Typography variant="subtitle1">{qa.desc}</Typography>
              </Grid>
              <Grid item display={'flex'} alignItems={'center'} columnGap={1} xs={12} md={10}>
                <Typography variant="subtitle1">A:</Typography>
                <TextField multiline minRows={2} fullWidth disabled value={qa.answer?.desc ?? ''} />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Section>
  );
};

export default QnASection;
